import {
  CommunicationByAttendeeResponse,
  CommunicationCreateData,
  CommunicationPageResponse,
} from "@/types/communication";
import { apiUrl } from "../../utils/url";
import { HttpClient } from "../HttpClient";
import { getErrorMessage } from "../errors";
import { ICommunicationService } from "./ICommunicationService";

export class CommunicationService implements ICommunicationService {
  private httpClient: HttpClient;

  constructor() {
    this.httpClient = new HttpClient({
      baseURL: apiUrl,
      timeout: 10000,
      headers: {},
    });
  }

  async getAll(page: number, size: number): Promise<CommunicationPageResponse> {
    try {
      return await this.httpClient.get<CommunicationPageResponse>(
        `/communication?page=${page}&size=${size}`,
      );
    } catch (error) {
      const errorMessage = getErrorMessage(
        error,
        "Não foi possível carregar as comunicações. Atualize a página e tente novamente.",
      );
      throw new Error(errorMessage);
    }
  }

  async create(communicationData: CommunicationCreateData): Promise<number> {
    try {
      return await this.httpClient.post<number>(
        `/communication`,
        communicationData,
        {},
        true,
      );
    } catch (error) {
      const errorMessage = getErrorMessage(
        error,
        "Não foi possível criar a comunicação. Confirme o modelo e os destinatários.",
      );
      throw new Error(errorMessage);
    }
  }

  async getByAttendee(
    attendeeId: number,
    options?: {
      onlyShowFollowUps?: boolean;
      onlyShowTemplated?: boolean;
      page?: number;
      size?: number;
    },
  ): Promise<CommunicationByAttendeeResponse> {
    try {
      const queryParams = new URLSearchParams();

      if (options?.page != null) {
        queryParams.append("page", options.page.toString());
      }
      queryParams.append("size", (options?.size ?? 5).toString());
      if (options?.onlyShowFollowUps) {
        queryParams.append("onlyShowFollowUps", "true");
      }
      if (options?.onlyShowTemplated) {
        queryParams.append("onlyShowTemplated", "true");
      }

      const queryString =
        queryParams.toString() !== "" ? `?${queryParams.toString()}` : "";

      const data = await this.httpClient.get<CommunicationByAttendeeResponse>(
        `/communication/attendee/${attendeeId}${queryString}`,
      );

      return data;
    } catch (error) {
      const errorMessage = getErrorMessage(
        error,
        "Não foi possível carregar as comunicações do animal. Atualize a página e tente novamente.",
      );
      throw new Error(errorMessage);
    }
  }
}
